<template>
    <section id="checkout-thanks-information">
        <div class="row alert-warning alert-custom-padding info-custom-width">
            <div class="col-auto d-flex justify-content-center align-items-center">
                <font-awesome-icon icon="fa-regular fa-id-card" class="fa-2x" />
            </div>
            <div class="col d-flex align-items-center no-padding-left">
                <div>{{$t('co.final.information.text')}}</div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'CheckoutThanksInformation',
}
</script>
